import { render, staticRenderFns } from "./PaypalErrorPageView.vue?vue&type=template&id=0783b2e4&"
import script from "./PaypalErrorPageView.vue?vue&type=script&lang=js&"
export * from "./PaypalErrorPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports